import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* eslint-disable jsx-a11y/no-static-element-interactions */
import "./scss/index.scss";
import { useCart, useSignOut, useUserDetails } from "@sdk/react";
import classNames from "classnames";
import React from "react";
import { useIntl } from "react-intl";
import Media from "react-media";
import { Link, NavLink } from "react-router-dom";
import ReactSVG from "react-svg";
import { RudderAnalytics } from "@temp/app/analitics";
import { MenuDropdown, Offline, Online, OverlayContext, OverlayTheme, OverlayType } from "..";
import { PrismicNavDropdown } from "../../@prismic/components/PrismicNav/PrismicNavDropdown";
import * as appPaths from "../../app/routes";
import { maybe } from "../../core/utils";
import { mediumScreen, smallScreen } from "../../globalStyles/scss/variables.scss";
import cartImg from "../../images/cart.svg";
import hamburgerHoverImg from "../../images/hamburger-hover.svg";
import hamburgerImg from "../../images/hamburger.svg";
import heartImg from "../../images/heart.svg";
import logoMobile from "../../images/logo-mobile.svg";
import logoImg from "../../images/logo.svg";
import userImg from "../../images/user.svg";
import userImgLogged from "../../images/userLogged.svg";
import { LocaleDropdown } from "./LocaleDropdown";
import NavDropdown from "./NavDropdown";
import { TypedMainMenuQuery } from "./queries";
import { WishlistCount } from "./WishlistCount"; // import searchImg from "../../images/search.svg";
// import likeImg from "../../images/like.svg";

var MainMenu = function MainMenu(_ref) {
  var prismicNav = _ref.prismicNav,
      allTypesImage = _ref.allTypesImage,
      contact = _ref.contact,
      isScrolled = _ref.isScrolled;
  var intl = useIntl();

  var _useUserDetails = useUserDetails(),
      user = _useUserDetails.data;

  var _useSignOut = useSignOut(),
      _useSignOut2 = _slicedToArray(_useSignOut, 1),
      signOut = _useSignOut2[0];

  var _useCart = useCart(),
      cartItems = _useCart.items;

  var handleSignOut = function handleSignOut() {
    // @analitics
    RudderAnalytics.identify("", {
      isLoggedIn: false
    });
    signOut();
  };

  var cartItemsQuantity = cartItems && cartItems.reduce(function (prevVal, currVal) {
    return prevVal + currVal.quantity;
  }, 0) || 0;
  return React.createElement(OverlayContext.Consumer, null, function (overlayContext) {
    return React.createElement("nav", {
      className: classNames("main-menu container-flex", {
        "main-menu--shrinked": isScrolled
      }),
      id: "header"
    }, React.createElement(Link, {
      to: appPaths.baseUrl,
      className: "main-menu__logo"
    }, React.createElement("img", {
      src: logoImg,
      alt: "Reno",
      className: "main-menu__logo-desktop"
    }), React.createElement("img", {
      width: "24px",
      height: "30px",
      src: logoMobile,
      alt: "Reno",
      className: "main-menu__logo-mobile"
    })), React.createElement("div", {
      className: "main-menu__center"
    }, React.createElement(TypedMainMenuQuery, {
      renderOnError: true,
      displayLoader: false
    }, function (_ref2) {
      var data = _ref2.data;
      var items = maybe(function () {
        return data.shop.navigation.main.items;
      }, []);
      return React.createElement("ul", {
        className: "main-menu__nav"
      }, React.createElement(Media, {
        query: {
          maxWidth: mediumScreen
        },
        render: function render() {
          return React.createElement("li", {
            className: "main-menu__hamburger",
            onClick: function onClick() {
              return overlayContext.show(OverlayType.sideNav, OverlayTheme.left, {
                data: {
                  allTypesImage: allTypesImage,
                  contact: contact,
                  items: items,
                  prismicNav: prismicNav
                }
              });
            }
          }, React.createElement(ReactSVG, {
            path: hamburgerImg,
            className: "main-menu__hamburger--icon"
          }), React.createElement(ReactSVG, {
            path: hamburgerHoverImg,
            className: "main-menu__hamburger--hover"
          }));
        }
      }), items === null || items === void 0 ? void 0 : items.map(function (item) {
        return (// <li
          //   data-cy="main-menu__item"
          //   className="main-menu__item"
          //   key={item.id}
          // >
          React.createElement(NavDropdown, _extends({
            allTypesImage: allTypesImage,
            overlay: overlayContext,
            key: item === null || item === void 0 ? void 0 : item.id
          }, item)) // </li>

        );
      }), React.createElement(Media, {
        query: {
          minWidth: mediumScreen
        },
        render: function render() {
          var _ref3;

          return (_ref3 = prismicNav === null || prismicNav === void 0 ? void 0 : prismicNav.map(function (prismicItem, i) {
            return React.createElement("li", {
              key: i,
              className: "main-menu__item prismic-nav__item"
            }, React.createElement(PrismicNavDropdown, _extends({
              overlay: overlayContext
            }, prismicItem)));
          })) !== null && _ref3 !== void 0 ? _ref3 : null;
        }
      }));
    })), React.createElement("div", {
      className: "main-menu__right"
    }, React.createElement("ul", null, React.createElement("li", null, React.createElement(LocaleDropdown, {
      overlay: overlayContext
    })), React.createElement(Online, null, React.createElement(React.Fragment, null, user ? React.createElement(NavLink, {
      to: "/wishlist",
      className: "main-menu__nav-link"
    }, React.createElement(ReactSVG, {
      path: heartImg,
      className: "main-menu__wishlist-icon"
    }), React.createElement(WishlistCount, null)) : React.createElement("a", {
      className: "main-menu__nav-link",
      onClick: function onClick(e) {
        e.preventDefault();
        overlayContext.show(OverlayType.login, OverlayTheme.modal);
      }
    }, React.createElement(ReactSVG, {
      path: heartImg,
      className: "main-menu__wishlist-icon"
    })), React.createElement(Media, {
      query: {
        minWidth: smallScreen
      },
      render: function render() {
        return user ? React.createElement(MenuDropdown, {
          head: React.createElement("li", {
            className: "main-menu__icon main-menu__user".concat(user ? "--active" : "")
          }, React.createElement(ReactSVG, {
            path: user ? userImgLogged : userImg
          })),
          content: React.createElement("ul", {
            className: "main-menu__dropdown"
          }, React.createElement("li", {
            "data-testid": "my_account__link"
          }, React.createElement(Link, {
            to: appPaths.orderHistoryUrl
          }, intl.formatMessage(_defineProperty({
            defaultMessage: "My orders",
            "id": "components.MainMenu.MainMenu.1045389126"
          }, "id", "components.MainMenu.MainMenu.1045389126")))), React.createElement("li", {
            "data-testid": "order_history__link"
          }, React.createElement(Link, {
            to: appPaths.accountUrl
          }, intl.formatMessage(_defineProperty({
            defaultMessage: "Personal details",
            "id": "components.MainMenu.MainMenu.3253048083"
          }, "id", "components.MainMenu.MainMenu.3253048083")))), React.createElement("li", {
            "data-testid": "address_book__link"
          }, React.createElement(Link, {
            to: appPaths.addressBookUrl
          }, intl.formatMessage(_defineProperty({
            defaultMessage: "Billing address",
            "id": "components.MainMenu.MainMenu.2428885633"
          }, "id", "components.MainMenu.MainMenu.2428885633")))), React.createElement("li", {
            "data-testid": "address_book__link"
          }, React.createElement(Link, {
            to: appPaths.addressBookUrl
          }, intl.formatMessage(_defineProperty({
            defaultMessage: "Shipping address",
            "id": "components.MainMenu.MainMenu.3517722732"
          }, "id", "components.MainMenu.MainMenu.3517722732")))), React.createElement("li", {
            onClick: handleSignOut,
            "data-testid": "logout-link"
          }, intl.formatMessage(_defineProperty({
            defaultMessage: "Log Out",
            "id": "components.MainMenu.MainMenu.2947231211"
          }, "id", "components.MainMenu.MainMenu.2947231211"))))
        }) : React.createElement("li", {
          "data-testid": "login-btn",
          className: "main-menu__icon",
          onClick: function onClick() {
            return overlayContext.show(OverlayType.login, OverlayTheme.modal);
          }
        }, React.createElement(ReactSVG, {
          path: userImg
        }));
      }
    })), React.createElement("li", {
      className: "main-menu__icon main-menu__cart",
      onClick: function onClick() {
        overlayContext.show(OverlayType.cart, OverlayTheme.right);
      }
    }, React.createElement(ReactSVG, {
      path: cartImg
    }), cartItemsQuantity > 0 ? React.createElement("span", {
      className: "main-menu__cart__quantity"
    }, cartItemsQuantity) : null)), React.createElement(Offline, null, React.createElement("li", {
      className: "main-menu__offline"
    }, React.createElement(Media, {
      query: {
        minWidth: mediumScreen
      },
      render: function render() {
        return React.createElement("span", null, intl.formatMessage(_defineProperty({
          defaultMessage: "Offline",
          "id": "components.MainMenu.MainMenu.4144939532"
        }, "id", "components.MainMenu.MainMenu.4144939532")));
      }
    }))))));
  });
};

export default MainMenu;